import Icon from '../../components/Icon.vue'

Icon.register({"brands/opencart":{"width":640,"height":512,"paths":[{"d":"M423.3 440.7C423.3 466 403 486.3 377.7 486.3S331.9 466 331.9 440.7 352.5 394.9 377.7 394.9C403.1 394.9 423.3 415.4 423.3 440.7zM169.4 394.9C144.1 394.9 123.8 415.5 123.8 440.7S144.1 486.3 169.4 486.3 215.2 466 215.2 440.7 194.7 394.9 169.4 394.9zM461.1 124.9C158.9 124.9 81.9 112.1 0 25.7 34.4 77.4 53.3 174.6 373.1 169.9 706.4 164.9 503.1 256 443.9 358.8 630.6 192.1 763.3 124.9 461.1 124.9z"}]}})



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-awesome/icons/brands/opencart.js
// module id = null
// module chunks = 